import { AbstractControl, ValidatorFn } from '@angular/forms';

import { DOUBLEAT, EMAIL } from '../validators.expressions';

/*
 * https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 * This will take 2 params first is RegExp and the second is optional number.
 * Takes a formControlName that would be of type string and matches to RegExp.
 * Usage:
 *    import { mlpEmailValidator } from './validators.email';
 *
 * Example:
 *     this.form = this.fb.group({
 *          email: ['', [mlpEmailValidator()]]
 *     });
*/

export function mlpEmailValidator(): ValidatorFn {

    return (control: AbstractControl): {[key: string]: any} => {
        let hasRegExp;
        const EMAILMATCH = (control.value) ? control.value.match(EMAIL) : undefined;
        const DOUBLEATMATCH = (control.value) ? control.value.match(DOUBLEAT) : undefined;

        if (EMAILMATCH) hasRegExp = true;

        if (EMAILMATCH && DOUBLEATMATCH && DOUBLEATMATCH.length) {
            hasRegExp = (DOUBLEATMATCH.length >= 2) ? true : false;
        }

        return hasRegExp ? undefined : { invalidEmail: { value: control.value }} ;
    };
}
